import React, { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, FormControlLabel, Checkbox, Button, Box, Grid } from "@mui/material";
import { toast } from "react-toastify";
import ApiService from "../../services/categoryManagementApi";
import TemplateList from "./TemplateList";

const { NotificatiopnApi } = ApiService;

function NotificationManagement() {
  const [notifications, setNotifications] = useState({
    dealer: false,
    driver: false,
    user: false,
  });

  const [initialNotifications, setInitialNotifications] = useState({}); 

  useEffect(() => {
    const fetchNotification = async () => {
      try {
        const response = await NotificatiopnApi.getNotificationSetting();
        const data = response?.data?.data;

        const formattedData = {
          dealer: data?.dealerNotification || false,
          driver: data?.driverNotification || false,
          user: data?.userNotification || false,
        };

        setNotifications(formattedData);
        setInitialNotifications(formattedData); 
      } catch (error) {
        console.log("Error fetching notification", error);
        toast.error(error?.response?.data?.message, { toastId: "error" });
      }
    };
    fetchNotification();
  }, []);

  const handleChange = (event) => {
    setNotifications((prev) => ({
      ...prev,
      [event.target.name]: event.target.checked,
    }));
  };

  const handleSave = async () => {
    try {

      const response = await NotificatiopnApi.enableNotification(notifications);
      if (response.status === 200) {
        toast.success(response?.data?.message, { toastId: "success" });
        setInitialNotifications(notifications); 
      }
    } catch (error) {
      console.log("Notification Error", error);
      toast.error(error?.response?.data?.message, { toastId: "error" });
    }
  };

  const isChanged = JSON.stringify(notifications) !== JSON.stringify(initialNotifications);

  return (
    <>
    <Card>
      <CardHeader titleTypographyProps={{ variant: "h4" }} title="Notification Management" />
      <CardContent>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={<Checkbox checked={notifications.dealer} onChange={handleChange} name="dealer" />}
            label="Dealer Notifications"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={<Checkbox checked={notifications.driver} onChange={handleChange} name="driver" />}
            label="Driver Notifications"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={<Checkbox checked={notifications.user} onChange={handleChange} name="user" />}
            label="Customer Notifications"
          />
        </Grid>
        <Box mt={2}>
          <Button variant="contained" color="primary" onClick={handleSave} disabled={!isChanged}>
            Save
          </Button>
        </Box>
      </CardContent>
    </Card>
    <TemplateList notifications={notifications}/>
    </>
  );
}

export default NotificationManagement;
